import React from "react";
import { Outlet } from "react-router-dom";

const Tracks = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Tracks;
